import { Dimensions, View } from "react-native";
import React from "react";
import InnerLoading from "components/InnerLoading";
import Dialog from "components/Dialog";
import { Text } from "@ui-kitten/components";
import { resolveLogo } from "components/LoginContainer/utils";
import i18n from "plugins/localization";
import { useFetchTenantConfigurationQuery } from "queries/configuration.queries";

const WINDOW_HEIGHT = Dimensions.get("window").height;
const BallParkAccountNotFound = () => {
  const { data: tenantConfig } = useFetchTenantConfigurationQuery();

  if (!tenantConfig) {
    return (
      <View style={{ height: WINDOW_HEIGHT }}>
        <InnerLoading />
      </View>
    );
  }

  return (
    <View style={{ height: WINDOW_HEIGHT }}>
      <Dialog visible={true}>
        <View>
          <View
            style={{
              marginVertical: 10,
              alignSelf: "center",
            }}
          >
            {resolveLogo()}
          </View>
          <Text category="h6" selectable>
            We could not locate an existing {tenantConfig.programName}{" "}
            membership for you. In order to become a member, please visit{" "}
            <Text status="info" category="h6">
              {tenantConfig.buyflowRedirectUrl}
            </Text>{" "}
            to view available plans
          </Text>
        </View>
      </Dialog>
    </View>
  );
};

export default BallParkAccountNotFound;
